import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../localization/language';
import UserInfo from './mobile/UserInfo';
import ActionPanel from './mobile/ActionPanel';

import * as commonActions from '../actions/common';

class MobileRightPanel extends React.Component {
	handleLogout() {
		this.props.logout();
	}
	
	render() {
		return (
			<div className="msidebar-right-wrap" id="J-msidebar-right">
				<div className="msidebar-right">
					<div className="msidebar-right__top">
						<UserInfo />
						<ActionPanel />
					</div>
					<a href="#" className="msidebar-operation" onClick={this.handleLogout.bind(this)}>{trans('logout')}</a>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, commonActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileRightPanel);


// WEBPACK FOOTER //
// ./app/components/MobileRightPanel.js